/** Reads and JSON-parses a localStorage value, returning the fallback when missing or unparseable. */
export function getParsedStorageItem<T>(storageKey: string, fallback: T): T {
	const rawValue = localStorage.getItem(storageKey);
	if (rawValue === null) {
		return fallback;
	}
	try {
		return JSON.parse(rawValue) as T;
	} catch (error) {
		return fallback;
	}
}
